module.exports = __webpack_public_path__ + "static/media/verdeOccupy.0f012c47.jpg";